import DocumentTemplate from "../utils/services/documentTemplateServise.js";
import crudTemplate from "../templates/crudTemplate.js";
import massTemplate from "../templates/massTemplate";

let crud = crudTemplate(DocumentTemplate);
function prepareItem(i) {
  i._library = i._library || { id: null };
  return i;
}
const state = {
  ...crud.state
};
const getters = {
  ...crud.getters,
  getList(state, getters, rootState, rootGetters) {
    let types = rootGetters["documentTypeStore/getList"].reduce(
      (accumulator, type) => ({ ...accumulator, [type.id]: type.name }),
      {}
    );
    let list = crud.getters.getList(state);
    return list.map(i => ({ ...i, type_name: types[i.type] })).map(prepareItem);
  },
  getItem(state) {
    let item = crud.getters.getItem(state);
    return prepareItem(item);
  }
};

const actions = {
  ...crud.actions,
  clearItem({ commit }) {
    commit("set", {
      item: {}
    });
  },
  ...massTemplate(DocumentTemplate, "move").actions,
  ...massTemplate(DocumentTemplate, "copy").actions
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
